import React from 'react';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { formatDate } from '../../../../../utils'; 
const styles = {
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20,
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  columnHeader: {
    width: '20%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '20%',
    padding: 5,
    textAlign: 'center'
  }
};

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const GrnPdf = ({ data }) => {
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="GRN Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={{ marginBottom: 20 }}>
         

              {data.map((group, groupIndex) => (
                <View key={`group-${groupIndex}`} style={{marginBottom:"20px"}}>
                  <Text style={styles.groupHeader} content={`GRN : ${group.cnt}` || 'N/A'} />
                  <Text style={styles.groupHeader} content={`Invoice No. : ${group.invoice_no}` || 'N/A'} />
                  <Text style={styles.groupHeader} content={`Supplier : ${group.supplier_name}` || 'N/A'} />
                  <Text style={styles.groupHeader} content={`Location : ${group.location_name}` || 'N/A'} />
     <View style={styles.row}>
                <Text style={styles.columnHeader} content="Product Name" />
                <Text style={styles.columnHeader} content="Quantity" />
                <Text style={styles.columnHeader} content="Batch No" />
                <Text style={styles.columnHeader} content="Expiry Date" />
                <Text style={styles.columnHeader} content="Rate" />
                 <Text style={styles.columnHeader} content="Disc Amt" />
                <Text style={styles.columnHeader} content="Taxable Amount" />
                <Text style={styles.columnHeader} content="GST (%)" />
                  <Text style={styles.columnHeader} content="Net Amt" />
              </View>
                  {group.items.map((item, itemIndex) => (
                    <View
                      key={`${groupIndex}-${itemIndex}`}
                      style={{
                        ...styles.row,
                        backgroundColor: COLORS[(groupIndex + itemIndex) % COLORS.length]
                      }}
                    >
                      <Text style={styles.columnContent} content={item?.product?.main?.name || 'N/A'} />
                      <Text style={styles.columnContent} content={item.total_qty || 0} />
                      <Text style={styles.columnContent} content={item.batch_no || 'N/A'} />
                      <Text style={styles.columnContent} content={formatDate(item.exp_date)} />
                      <Text style={styles.columnContent} content={item.rate || 0} />
                      <Text style={styles.columnContent} content={item.dis_amt || 0} />
                      <Text style={styles.columnContent} content={item.taxable || 0} />
                      <Text style={styles.columnContent} content={item.gst || 0} />
                         <Text style={styles.columnContent} content={item.net_amt || 0} />
                    </View>
                  ))}
                </View>
              ))}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default GrnPdf;
